import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, RotateCcw } from "lucide-react";
import { Reveal } from "./Shared";
import { NAVIGATOR, NAVIGATOR_RESULTS } from "../data/content";

const getResult = (answers) => {
  const counts = {};
  answers.forEach((k) => { counts[k] = (counts[k] || 0) + 1; });
  return Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
};

export const SolutionNavigator = () => {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const done = step >= NAVIGATOR.length;
  const result = done ? NAVIGATOR_RESULTS[getResult(answers)] : null;

  const pick = (key) => {
    setAnswers([...answers, key]);
    setStep(step + 1);
  };
  const restart = () => { setAnswers([]); setStep(0); };

  return (
    <section className="section navy navigator-section" id="navigator">
      <div className="container">
        <Reveal className="navigator-head">
          <span className="eyebrow on-dark">Solution navigator</span>
          <h2>Not sure where to begin? Answer three quick questions.</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="navigator-card" data-testid="solution-navigator">
            <div className="navigator-progress">
              {NAVIGATOR.map((_, i) => (
                <span key={`prog-${i}`} className={`prog-dot${i < step || done ? " filled" : ""}${i === step && !done ? " current" : ""}`} />
              ))}
              <span className="prog-label">{done ? "Your recommendation" : `Question ${step + 1} of ${NAVIGATOR.length}`}</span>
            </div>
            <AnimatePresence mode="wait">
              {!done ? (
                <motion.div
                  key={step}
                  initial={{ opacity: 0, x: 40 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -40 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <h3>{NAVIGATOR[step].q}</h3>
                  <div className="navigator-options">
                    {NAVIGATOR[step].options.map((o) => (
                      <button key={o.label} onClick={() => pick(o.key)} data-testid={`navigator-option-${o.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                        {o.label}
                      </button>
                    ))}
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key="result"
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.45, ease: "easeOut" }}
                  className="navigator-result"
                  data-testid="navigator-result"
                >
                  <span className="tag">Recommended for you</span>
                  <h3>{result.title}</h3>
                  <p>{result.copy}</p>
                  <div className="navigator-result-actions">
                    <Link to={result.path} className="btn btn-primary" data-testid="navigator-result-cta">{result.cta} <ArrowUpRight size={16} /></Link>
                    <button className="btn btn-secondary" onClick={restart} data-testid="navigator-restart-button"><RotateCcw size={15} /> Start Over</button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
